module.exports = __webpack_public_path__ + "static/title1-fa703b18102f5fe78798d16352eb32f2.png";